import styled from "@emotion/styled";
// @ts-expect-error
import units from "design-units";
import { NavigationMenuConstants } from "./navigation-menu.constants";

export const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: ${NavigationMenuConstants.width}px;
  padding-top: 15px;
  position: sticky;
  top: 0;
  box-shadow: 1px 0 3px -2px #888;
  justify-content: space-between;
  overflow: auto;
  height: 100%;
  flex-shrink: 0;
  z-index: 21;

  ${units({
    backgroundColor: "white",
    borderRight: "1px solid",
    borderColor: "lightGrey",
  })};
`;

export const LogoWrapper = styled.div`
  width: 55%;
  pointer-events: none;
  margin-bottom: 50px;
  margin-left: 10px;
  margin-top: 1.25rem;
`;

export const LogoImgWrapper = styled.img`
  width: 100%;
  pointer-events: none;
  max-width: 100px;
`;

export const DCMLogoImgWrapper = styled.img`
  width: 36px;
  pointer-events: none;
`;

export const TopNav = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomNav = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0 1rem;
`;

export const FooterNav = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 14px;
`;

export const CopyrightWrapper = styled.span`
  ${units({
    fontSize: "caption",
  })};
`;
